import React from 'react';

import i18n from 'i18n-react';

import ContentHeader from 'components/ContentHeader';
import RetainGrid from 'components/RetainGrid';

const RetainView = () => (
  <div className="contentContainer retainView">
    <div className="backgroundImage" />
    <ContentHeader header={i18n.translate('nav.retain')} subtitle={i18n.translate('pageDescriptions.retain')} hr />
    <RetainGrid />
  </div>
);

export default RetainView;
